export const AppleConfig = {
  APPLE_PRIVATE_KEY:`-----BEGIN PRIVATE KEY-----
MIGTAgEAMBMGByqGSM49AgEGCCqGSM49AwEHBHkwdwIBAQQgNQcjfcD8JgPgIMDk
9nciYqTVBJvT6GK2AzMYj3hzoSKgCgYIKoZIzj0DAQehRANCAARWUwA8lkpz1Opi
Lv5BnNwqYRS3c7UeydNNz2mgQoW8wzTgMIGwc0U4IaKeNPf3MO1rODL7iMmDn+cP
bSYDO/Ve
-----END PRIVATE KEY-----`,
  APPLE_TEAM_ID:'5T5ZCS2643',
  APPLE_KEY_ID:'A7K9GMWD96',
  APPLE_SERVICE_ID:'ppleWebDev',
  APPLE_ALGORISM:'ES256',
  APPLE_EXPIRESIN:'1h'
}
